import useUserCardContext from "../UserCardContext";

function UserCardName() {
	const { user } = useUserCardContext() as any;
	return <h4>{user?.full_name || user?.name}</h4>;
}

export default UserCardName;
